(function () {
	'use strict';

	angular
	.module('core')
	.filter('highlightText', highlightText);

	function highlightText(){
		return function(text, selectedWords) {
			if(selectedWords) {
				var newText = angular.copy(text);
				angular.forEach(selectedWords, function(selectedWord){
					var pattern = new RegExp(selectedWord, "g");
					newText = newText.replace(pattern, '<span class="highlighted">' + selectedWord + '</span>')
				});
				
				return newText;
			}
			else {
				return text;
			}
		}
	}

	angular
	.module('core')
	.filter('nl2br', nl2br);

	function nl2br($sanitize){
		var tag = (/xhtml/i).test(document.doctype) ? '<br />' : '<br>';
		return function(msg) {
			// ngSanitize's linky filter changes \r and \n to &#10; and &#13; respectively
			msg = (msg + '').replace(/(\r\n|\n\r|\r|\n|&#10;&#13;|&#13;&#10;|&#10;|&#13;)/g, tag + '$1');
			return $sanitize(msg);
		};
	}

	angular
	.module('core')
	.filter('startsWith', startsWith);

	function startsWith(){
		return function(input, search) {
			if (!input) return input;
			if (!search) return input;

			var result = [];
			angular.forEach(input, function(value) {
				if(value.indexOf(search) == 0){
					result.push(value);
				}
			});
			return result;
		}
	}

	angular
	.module('core')
	.filter('contains', contains);

	function contains(){
		return function(input, search) {
			if (!input) return input;
			if (!search) return input;

			var result = [];
			angular.forEach(input, function(value) {
				if(value.toLowerCase().indexOf(search.toLowerCase()) >= 0){
					result.push(value);
				}
			});
			return result;
		}
	}

	angular
	.module('core')
	.filter('custom', custom);

	function custom(){
		return function(input, search) {
			if (!input) return input;
			if (!search) return input;

			var result = {};
			angular.forEach(input, function(value, key) {
				if(search(value)){
					result[key] = value;
				}
			});
			return result;
		}
	}

	angular
	.module('core')
	.filter('order', order);

	function order(){
		return function(items, field, reverse) {
			var filtered = [];
			angular.forEach(items, function(item) {
				filtered.push(item);
			});
			filtered.sort(function (a, b) {
				if(typeof field == 'string' && a[field] != undefined && b[field] != undefined){
					return (a[field] > b[field] ? 1 : -1);
				}
				else {
					var _a = a;
					var _b = b;
					angular.forEach(field, function(search){
						_a = _a[search];
						_b = _b[search];
					});

					return (_a > _b ? 1 : -1);
				}
			});
			if(reverse) filtered.reverse();
			return filtered;
		}
	}

})();